import {
	apiPost,
	type ErrorResponse,
	type FetchResponse,
	getApiUrl,
	type PartnerCalendarRequestDto,
} from "Infrastructure/Api/Api";

export type PartnerCalendarRequest = PartnerCalendarRequestDto & {
	sortByAvailabilityDate?: string | null;
};

type PartnerCalendarEmailsResponse = {
	emails: string[];
};

type PostPartnerCalendarEmailsResponse =
	| FetchResponse<PartnerCalendarEmailsResponse, 200>
	| ErrorResponse;

export function postPartnerCalendarEmails(
	request: PartnerCalendarRequest,
	headers = new Headers(),
): Promise<PostPartnerCalendarEmailsResponse> {
	return apiPost(
		`${getApiUrl()}/partners/calendar/emails`,
		request,
		headers,
	) as Promise<PostPartnerCalendarEmailsResponse>;
}
